$(document).ready(function() {
	var currency = $.cookie('currency');
	if (currency) {
		$("#currencySelection").val(currency);
	}

	var siteLocale = $.cookie('siteLocale');
	if (siteLocale) {
		$('#languageSelection').val(siteLocale);
    }

	window.onpopstate = function() {
	    var open_modal = document.querySelector('.modal.show')
	    if (open_modal) {
	        open_modal.dataset.pushback = 'true';
	        $(open_modal).modal('hide')
	    }
	}
	
	window.onunload = function() {
	    var open_modal = document.querySelector('.modal.show')
	    if (open_modal) {
	        open_modal.dataset.pushback = 'true';
	        $(open_modal).modal('hide')
	    }
	}

	$('#loading').modal('hide');
	
	$(".loading-link").click(function() {
		$('#loading').modal('show');
	});
	
	window.onscroll = function () {
	  scrollFunction();
	};
});

function currencyChanged() {
	var currency = $('#currencySelection').val();
	if (currency) {
		$.cookie('currency', currency, {
			expires : 365,
			path : '/'
		});
		
		try {
			var curr = $('input[type=hidden][name=reload_currency]');
			if(curr != null && curr.length > 0)
				$('input[type=hidden][name=reload_currency]').val(currency);
			else{
				var postForm = $("#postForm");
				$('<input>').attr({
					type: 'hidden',
				    name: 'reload_currency',
				    value: currency
				}).appendTo(postForm);
			}

		} catch (e) {
			// TODO: handle exception
		}
	}
	$('#loading').modal('show');
	reloadPage();
}

function languageChanged() {
	var lang = $('#languageSelection').val();
	if (lang) {
		$.cookie('siteLocale', lang, {
			expires : 365,
			path : '/'
		});

	}
	$('#loading').modal('show');
	reloadPage();
}
	
// When the user clicks on the button, scroll to the top of the document
function backToTop() {
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
}
	
// When the user scrolls down 20px from the top of the document, show the button
function scrollFunction() {
  var mybutton = document.getElementById("btn-back-to-top");
  
  if (
    document.body.scrollTop > 500 ||
    document.documentElement.scrollTop > 500
  ) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

function reloadPage() {
	window.location.reload();
}

function closePrivacyBox(){
	$('#dialog').hide();
	setPrivacyValueToCookie("privacyPopup", "closed");
	
}
function setPrivacyValueToCookie(name, value) {
		$.cookie(name, value, { expires : 365, path : '/' });
}

function setTimezoneCookie(){

    var timezone_cookie = "timezoneoffset";

    // if the timezone cookie not exists create one.
    if (!$.cookie(timezone_cookie)) {

        // check if the browser supports cookie
        var test_cookie = 'test cookie';
        $.cookie(test_cookie, true);

        // browser supports cookie
        if ($.cookie(test_cookie)) {

            // delete the test cookie
            $.cookie(test_cookie, null);

            // create a new cookie
            $.cookie(timezone_cookie, new Date().getTimezoneOffset());
        }
    }
    // if the current timezone and the one stored in cookie are different
    // then store the new timezone in the cookie and refresh the page.
    else {

        var storedOffset = parseInt($.cookie(timezone_cookie));
        var currentOffset = new Date().getTimezoneOffset();

        // user may have changed the timezone
        if (storedOffset !== currentOffset) {
            $.cookie(timezone_cookie, new Date().getTimezoneOffset());
        }
    }
}
